import { toast } from "react-toastify";
import Api from "../../../axios";
import { callLoader } from "../../../common/actions/app";

let ACTION_CHECK_INITIALIZE_LIST = {
    type: 'CHECK_INITIALIZE_LIST',
    payload: {
        rows: [],
        total: 0,
        pagination: [],
        initialized: '',
    },
};

let callCheckInitializeListGet = (filter = {}, pg = 1) => (dispatch) => {
    dispatch(callLoader(true))
    filter.pg = pg;
    Api.get('/checks-initialize?' + (new URLSearchParams(filter)).toString()).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        ACTION_CHECK_INITIALIZE_LIST.payload.rows = data.rows
        ACTION_CHECK_INITIALIZE_LIST.payload.total = data.total
        ACTION_CHECK_INITIALIZE_LIST.payload.pagination = data.pagination
        ACTION_CHECK_INITIALIZE_LIST.payload.initialized = data.initialized
        dispatch(ACTION_CHECK_INITIALIZE_LIST)
    })
}

let callCheckInitializePost = (data, success = () => { }) => (dispatch) => {
    dispatch(callLoader(true))
    Api.post('/checks', data).then((data) => {
        dispatch(callLoader(false))
        if (!data)
            return

        toast.success(data.msg)
        success()
    })
}

export { callCheckInitializeListGet, callCheckInitializePost, ACTION_CHECK_INITIALIZE_LIST }